import createSpinner from "../../../../Shared/Functions/createSpinner";
import { customAutoCompleteFilter } from "../../../../Shared/GlobalVariables/filterVariables";

export default /*@ngInject*/ function ($rootScope, helperService, connectionsDataService, configurationDataService) {

    const vm = this;

    vm.$onInit = init;

    vm.objectsDropdownChange = objectsDropdownChange;
    vm.updateField = updateField;
    vm.update = update;
    vm.getConfigNames = getConfigNames;
    vm.configValuesHaveChanged = configValuesHaveChanged;
    vm.productValuesHaveChanged = productValuesHaveChanged;
    vm.logAnalyticConfigsHaveChanged = logAnalyticConfigsHaveChanged;
    vm.ax7ImportDisabledUsersChange = ax7ImportDisabledUsersChange;
    vm.ax7ImportDisabledUserAccessChange = ax7ImportDisabledUserAccessChange;
    vm.ax7ImportCustomTelemetryChange = ax7ImportCustomTelemetryChange;
    vm.sfImportTypeChange = sfImportTypeChange;

    async function init() {
        let config = vm.product.Config;

        // For now, only gather ALA if plugin is active & product is D365FSC
        if (vm.product.ID === 'AX7' || vm.product.ID === 'D365Bc') {
            await aLAPluginActive();
        }

        vm.hasChangeTracking = vm.modules.some(item => item.ObjectID === 3000);
        vm.versionOptions = vm.product.VersionOptions;
        vm.updateConfig = updateConfig;
        vm.originalProduct = Object.assign({}, vm.product);

        if (config && config.length) {
            vm.configNames = vm.product.Config.map((configItem) => configItem.Name);
        } else {
            vm.configNames = [];
        }

       if (vm.product.ID === "SF") {
           await setSalesForceObjects();
       }
    }

    async function aLAPluginActive() {
        const { data: configData } = await configurationDataService.getConfigurationValueByName('ALA_Active');
        vm.aLAPluginActive = configData;

        if (vm.aLAPluginActive) {
            try {
                const { data: connectionData } = await connectionsDataService.getLogAnalyticConnections(vm.product.ID);
                vm.originalLogAnalyticConfigs = {...connectionData};
                vm.logAnalyticConfigs = connectionData;
                vm.logAnalyticConfigs.ConnectionExists = true;
            } catch {
                vm.originalLogAnalyticConfigs = { "WorkspaceId" : null, "Instance" : null, "DaysToImport" : null };
                vm.logAnalyticConfigs = { "WorkspaceId": null, "Instance": null, "DaysToImport": null };
                vm.logAnalyticConfigs.ConnectionExists = false;
            }
        }
    }

    function getConfigNames() {
        return vm.configNames;
    }

    function configValuesHaveChanged (configArray = []) {
        return helperService.returnTrueIfValuesDiffer(configArray, vm.originalConfig, vm.currentConfig);
    };

    function productValuesHaveChanged(product) {
        return !angular.equals(vm.originalProduct, product);
    }

    function logAnalyticConfigsHaveChanged() {
        const logAnalyticConfigArray = ['WorkspaceId', 'Instance', 'DaysToImport'];

        return helperService.returnTrueIfValuesDiffer(logAnalyticConfigArray, vm.originalLogAnalyticConfigs, vm.logAnalyticConfigs);
    }

    async function update() {
        vm.updatePending = new createSpinner();

        if (vm.product.ID === 'AX5') {
            updateSqlConnection(vm.product);
            vm.updateConfig(vm.product.Config, vm.currentConfig, vm.originalConfig);
        } else if ((vm.product.ID === 'AX7' || vm.product.ID === 'D365Bc') && vm.aLAPluginActive) {
            if (logAnalyticConfigsHaveChanged()) {
                updateLogAnalyticsConfig(vm.logAnalyticConfigs);
            }
            if (configValuesHaveChanged(getConfigNames())) {
                vm.updateConfig(vm.product.Config, vm.currentConfig, vm.originalConfig);
            }
        } else if (vm.product.ID === 'SL') {
            updateSqlConnection(vm.product);
            vm.updateConfig(vm.product.Config, vm.currentConfig, vm.originalConfig);
        } else {
            vm.updateConfig(vm.product.Config, vm.currentConfig, vm.originalConfig);
        }
    }

    async function updateConfig(list, value, origVal) {
        let updateNsRoles = false,
            data = {
            "Configurations": []
        };

        list.forEach(item => {
            if (item.Name === 'NS_InactiveRoles') {
                updateNsRoles = true;
            }
            if (item.Encrypted === true) {
                if (value[item.Name] !== "password" && value[item.Name] !== "apikey") {
                    data.Configurations.push({
                        "Name": item.Name,
                        "Value": value[item.Name]
                    });
                }
            } else {
                if (value[item.Name] != origVal[item.Name]) {
                    data.Configurations.push({
                        "Name": item.Name,
                        "Value": value[item.Name]
                    });
                }
            }
        });

        vm.updatePending = new createSpinner();

        if (vm.product.ID === "NS") {
            try {
                await connectionsDataService.validateNsConfig(getNsValidationData(vm.currentConfig));
                await connectionsDataService.updateConfig(data);

                data.Configurations.forEach(config => {
                    origVal[config.Name] = config.Value;
                });
                helperService.successfulSaveButton(vm.updatePending);
                $rootScope.reloadConfigurationValues();

                if (updateNsRoles) {
                    const configChanged = true;
                    vm.onUpdateNsRoleDropdown({ configChanged });
                }
            } catch {
                vm.updatePending.loadingValue = false
            }
        } else {
            try {
                await connectionsDataService.updateConfig(data);

                data.Configurations.forEach(config => {
                    origVal[config.Name] = config.Value;
                });
                helperService.successfulSaveButton(vm.updatePending);
                $rootScope.reloadConfigurationValues();
            } catch {
                vm.updatePending.loadingValue = false
            }
        }
    };

    async function updateLogAnalyticsConfig(configs) {
        var postData = {
            "ProductId": vm.product.ID,
            "WorkspaceId": configs.WorkspaceId,
            "Instance": configs.Instance,
            "DaysToImport": configs.DaysToImport,
        };

        vm.updatePending = new createSpinner();

        //Update Connection
        if (vm.logAnalyticConfigs.ConnectionExists === true) {
            try {
                await connectionsDataService.updateLogAnalyticsConfig(vm.product.ID, postData);
                vm.originalLogAnalyticConfigs = postData;
                helperService.successfulSaveButton(vm.updatePending);
            } catch {
                vm.updatePending.loadingValue = false;
            }
        }
        else {
            try {
                await connectionsDataService.createLogAnalyticsConfig(vm.product.ID, postData);
                vm.logAnalyticConfigs.ConnectionExists = true;
                vm.originalLogAnalyticConfigs = postData;
                helperService.successfulSaveButton(vm.updatePending);
            } catch {
                vm.updatePending.loadingValue = false;
            }
        }
    };

    async function updateSqlConnection(product) {
        var postData = {
            "ProductId": product.ID,
            "DatabaseName": product.SQL_DatabaseName,
            "HostName": product.SQL_HostName,
            "Instance": product.SQL_Instance,
            "Port": product.SQL_Port,
            "Password": product.SQL_Password,
            "UserName": product.SQL_User
        };

        if (vm.originalConfig.SQL_Password === product.SQL_Password) {
            delete postData.Password;
        }

        vm.updatePending = new createSpinner();

        //Update Connection
        if (product.ConnectionExists === true) {
            try {
                await connectionsDataService.updateSqlConfig(product.ID, postData);
                helperService.successfulSaveButton(vm.updatePending);
            } catch {
                vm.updatePending.loadingValue = false;
            }
        }
        else {
            try {
                await connectionsDataService.createSqlConfig(product.ID, postData);
                product.ConnectionExists = true;
                helperService.successfulSaveButton(vm.updatePending);
            } catch {
                vm.updatePending.loadingValue = false;
            }
        }
    };

    async function setSalesForceObjects() {
        var fieldPermissionConfigurationGridColumns = [
            { template: "<label class='switch'><input type='checkbox' ng-model='dataItem.enabled' ng-change='csvm.updateField(dataItem)'><i></i></label>", width: 55, filterable: false },
            { field: "displayLabel", title: "Name", filterable: customAutoCompleteFilter }
        ];

        await getObjects();

        vm.fieldPermissionConfigurationGridOptions = helperService.setNonPageableGridOptions(fieldPermissionConfigurationGridColumns, 300);
        vm.fieldPermissionConfigurationGridOptions.autoBind = false;
        vm.fieldPermissionConfigurationGridOptions.noRecords = {
            template: "<div class='no-data-to-display-message'>No items to display</div>"
        };

        vm.fieldPermissionConfigurationGridDataSource = new kendo.data.DataSource({
            transport: {
                read: async options => {
                    try {
                        let response = await connectionsDataService.getSfPermissionConfigByObject(vm.selectedObject.name);
                        options.success(response.data);
                    } catch {
                        options.error();
                    }
                }
            }
        });
    }

    function ax7ImportDisabledUsersChange() {
        if (vm.currentConfig.AX7_AS_ShowDisabledUsers === "0") {
            vm.currentConfig.AX7_AS_ImportDisabledUserAccess = "0";
        }
    }

    function ax7ImportDisabledUserAccessChange() {
        if (vm.currentConfig.AX7_AS_ImportDisabledUserAccess === "1") {
            vm.currentConfig.AX7_AS_ShowDisabledUsers = "1";
        }
    }

    function ax7ImportCustomTelemetryChange() {
        if (vm.currentConfig.AX7_TelemetryCustomQueriesEnabled === "1") {
            vm.currentConfig.AX7_TelemetryCustomQueriesEnabled = "1";
        } }

    async function getObjects() {
        let response;

        vm.objectsDropdownLoading = true;

        try {
            response = await connectionsDataService.getSfPermissionConfig();

            if (typeof response.data === "string") {
                vm.invalidOrMissingCredentials = response.data;
            } else {
                vm.invalidOrMissingCredentials = null;
                vm.objectsDropdownDataSource = response.data;
                vm.selectedObject = vm.objectsDropdownDataSource[0];
                vm.objectsDropdownLoading = false;
                vm.fieldPermissionConfigurationGridDataSource.page(1);
                vm.objectsDropdownLoading = false;
            }
        } catch {
            vm.objectsDropdownLoading = false;
        }
    }

    function objectsDropdownChange() {
        vm.fieldPermissionConfigurationGridDataSource.read();
    }

    async function updateField(field) {
        if (field.enabled) {
            let data = {
                "Field": field.name,
                "FieldLabel": field.label,
                "SobjectType": vm.selectedObject.name,
                "ObjectLabel": vm.selectedObject.label
            },
                response;

            response = await connectionsDataService.createSfFieldPermissionConfig(data);
            field.Id = response.data;
        } else {
            await connectionsDataService.removeSfFieldPermissionConfig(field.Id);
        }
    }

    function getNsValidationData(config) {
        return {
            Account: config.NS_Account,
            TokenKey: config.NS_TokenKey,
            TokenSecret: config.NS_TokenSecret
        }
    }

    function sfImportTypeChange() {
        if (vm.currentConfig.SF_ImportType === '1') {
            vm.currentConfig.SF_UserName = null;
            vm.currentConfig.SF_Password = null;
            vm.currentConfig.SF_SecurityToken = null;
        } else {
            vm.currentConfig.SF_Url = null;
            vm.currentConfig.SF_ClientId = null;
            vm.currentConfig.SF_ClientSecret = null;
        }
    }
}
